import { Card, Col, Flex, Image, Row, Switch } from "antd";
import bkash from "../../../../../assets/images/bKash.svg";
import nagad from "../../../../../assets/images/nagad.svg";
import rocket from "../../../../../assets/images/roket.svg";
import sheba_pay from "../../../../../assets/images/sheba-pay.svg";

type Props = {
  data: any;
};

const IMAGE_CONFIG = {
  shebapay: sheba_pay,
  bkash: bkash,
  rocket: rocket,
  nagad: nagad,
};

export default function MFSCard({ data }: Props) {
  if (!data?.mfsAccount) return null;
  const { mfsAccount, is_default } = data || {};

  const type = (mfsAccount?.mfs_type as string)?.toLowerCase();
  const logo = IMAGE_CONFIG[type as keyof typeof IMAGE_CONFIG];

  return (
    <Card className="shadow-sm rounded-xl !w-full border-none bg-theme-slate-25">
      <Row gutter={[16, 16]}>
        {/* Logo */}
        <Col span={24} style={{ textAlign: "left" }}>
          <Flex justify="space-between" align="start">
            <Image
              src={mfsAccount?.mfs_logo || logo}
              alt="City Bank"
              height={80}
              preview={false}
            />
          </Flex>
        </Col>

        {/* Left column */}
        <Col span={24}>
          <p className="text-theme-gray-500 font-medium text-sm">
            Account Name
          </p>
          <p className="text-theme-gray-900 font-medium text-sm mb-1.5">
            {mfsAccount?.account_name}
          </p>

          <p className="text-theme-gray-500 font-medium text-sm">
            Account Number
          </p>
          <p className="text-theme-gray-900 font-medium text-sm">
            {mfsAccount?.account_number}
          </p>
        </Col>
      </Row>
      {/* Switch at bottom */}
      <Flex align="center" gap={8} className="mt-4">
        <Switch disabled checked={is_default} />
        <span className="text-theme-gray-24 font-medium">Set as Default</span>
      </Flex>
    </Card>
  );
}
